import {useFormField} from "@/components/ui/form";
import {cn} from "@/lib/utils";
import {useTranslation} from "react-i18next";

type SafelistingCoverageRulesCalloutProps = {
  loading?: boolean;
  todayWindowEnded?: boolean;
  className?: string;
};

export function SafelistingCoverageRulesCallout({
  loading = false,
  todayWindowEnded = false,
  className,
}: SafelistingCoverageRulesCalloutProps) {
  const {t} = useTranslation("common");
  const {formDescriptionId} = useFormField();

  if (!loading && !todayWindowEnded) {
    return <div id={formDescriptionId} data-slot="form-description" className="sr-only" aria-hidden />;
  }

  return (
    <div
      id={formDescriptionId}
      data-slot="form-description"
      className={cn("flex w-full flex-col gap-1", className)}
    >
      {loading ? (
        <p className="text-muted-foreground text-sm leading-snug">{t("loading")}</p>
      ) : todayWindowEnded ? (
        <p className="text-muted-foreground text-sm leading-snug">
          Today&apos;s coverage window has already ended — choose a later date.
        </p>
      ) : null}
    </div>
  );
}
